exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-chip-select-chip[data-v-6f851486]{border-radius:20px;display:inline-block;margin:0 5px;padding:5px 20px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sc-chip-select-unselected-chip[data-v-6f851486]{background-color:transparent;border:2px solid #edeeee;color:#2c3e50}.sc-chip-select-selected-chip[data-v-6f851486],.sc-chip-select-selected-chip[data-v-6f851486]:hover,.sc-chip-select-unselected-chip[data-v-6f851486]:hover{background-color:#599900;border:2px solid #599900;color:#fff}", ""]);

// exports
